// src/components/resources/ResourcesGrid.js
// Responsive grid layout for resource cards

import React from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import ResourceCard from './ResourceCard';
import './styles/resources-grid.css';

const gridVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
    },
  },
};

const ResourcesGrid = ({ resources }) => {
  const prefersReducedMotion = useReducedMotion();

  return (
    <section className="resources-grid">
      <div className="resources-grid__container">
        {/* All resources in single grid - featured cards span 2 columns inline */}
        <AnimatePresence mode="wait">
          <motion.div
            key={resources.map((r) => r.id).join(',')}
            className="resources-grid__grid"
            variants={prefersReducedMotion ? {} : gridVariants}
            initial="hidden"
            animate="visible"
          >
            {resources.map((resource, index) => (
              <ResourceCard
                key={resource.id}
                resource={resource}
                featured={resource.isFeatured}
                index={index}
              />
            ))}
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
};

export default ResourcesGrid;
